import * as types from "@/redux/ActionTypes";
import { CustumizationUserInfo } from "@/types/LoginInfo";

// Action interfaces
interface InterfaceAction {
  type: typeof types.INTERFACE;
  data: CustumizationUserInfo | null;
}

interface DefaultAction {
  type: string;
  data?: unknown;
}

type Action = InterfaceAction | DefaultAction;

export type InterfaceState = CustumizationUserInfo;

const initialState: InterfaceState = {};

const myReducer = (state: InterfaceState = initialState, action: Action): InterfaceState => {
  switch (action.type) {
    case types.INTERFACE:
      if ((action as InterfaceAction).data) {
        sessionStorage.setItem("customInterface", JSON.stringify((action as InterfaceAction).data));
      }
      return { ...(action as InterfaceAction).data };
    default:
      return state;
  }
};

export default myReducer;
